import { baseApi } from './baseApi';

export const announcementApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAnnouncements: builder.query({
      query: () => '/api/announcements',
    }),
  }),
});

export const { useGetAnnouncementsQuery } = announcementApi;
